module.exports = __webpack_public_path__ + "img/skull_10.62512a10.png";